import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { Event } from '@ifeng/ui_base';
import { LazyImg } from '@ifeng/ui_pc_lazyLoad';
import AsideTitle from '../asideTitle/';
import { rel } from '../../../../utils/rel';
import errorBoundary from '@ifeng/errorBoundary';
import { handleRecommendData } from '../../../../utils/utils';
import { handleAd } from '@ifeng/ui_pc_ad';

class HotList extends React.PureComponent {
    static propTypes = {
        title: PropTypes.string,
        content: PropTypes.array,
        data: PropTypes.array,
        ad: PropTypes.object,
        type: PropTypes.string,
        isFo: PropTypes.bool,
    };

    event = new Event();
    container = React.createRef();

    async componentDidMount() {
        const { ad } = this.props;

        try {
            const callback = await handleAd(ad);

            callback(ad.data, this.event);

            this.event.trigger('init', { container: this.container.current });
        } catch (e) {
            console.error(e);
        }
    }

    render() {
        const { content, data, title, type, isFo } = this.props;
        const isVideo = type === 'video';

        const result = isFo ? content : handleRecommendData(content, data);

        return (
            <div className={styles.hotList}>
                <AsideTitle title={title} />
                <ul ref={this.container}>
                    {result.map((item, index) => (
                        <li key={index}>
                            <a href={item.url} target="_blank" rel={rel}>
                                {item.img !== '' ? (
                                    <LazyImg src={item.img} alt={item.title} width="100" height="56" />
                                ) : (
                                    ''
                                )}
                                {isVideo && !isFo && item.img !== '' ? <div className={styles.play_btn} /> : ''}
                                <p className={styles.title}>{item.title}</p>
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
}

export default errorBoundary(HotList);
